module.exports = __webpack_public_path__ + "static/media/feishu_document.92bd0da1.png";